import { Route, Routes } from "react-router-dom";
import AboutPage from "./pages/AboutPage/AboutPage";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import FeedPage from "./pages/FeedPage/FeedPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import LogoutPage from "./pages/LogoutPage/LogoutPage";
import MapPage from "./pages/MapPage/MapPage";
import PlacePage from "./pages/PlacePage/PlacePage";
import PlayerPage from "./pages/PlayerPage/PlayerPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import RegistrationPage from "./pages/RegistrationPage/RegistrationPage";

const PublicAppRoutes = () => {
  return (
    <Routes>
      {/** PUBLIC ROUTES */}
      <Route path="/about" element={<AboutPage />} />
      <Route path="/feed" element={<FeedPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/map" element={<MapPage />} />
      <Route path="/place/:placeId" element={<PlacePage />} />
      <Route path="/player/:playerUsername" element={<PlayerPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/register" element={<RegistrationPage />} />

      {/** ERROR ROUTES */}
      <Route path="*" element={<ErrorPage userMessage="Page not found" />} />
    </Routes>
  );
};

export default PublicAppRoutes;
